import { render, staticRenderFns } from "./IndividualWorkList.vue?vue&type=template&id=4023f3b2"
import script from "./IndividualWorkList.vue?vue&type=script&lang=js"
export * from "./IndividualWorkList.vue?vue&type=script&lang=js"
import style0 from "./IndividualWorkList.vue?vue&type=style&index=0&id=4023f3b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports